import { useQuery } from '@tanstack/react-query';

import { api } from '../services/api';
import { useAuth } from '../stores/auth';

export const BILLING_INFO_QUERY_KEY = ['billing-info'] as const;

interface UseBillingInfoOptions {
  pollIntervalMs?: number | false;
}

export function useBillingInfo(options: UseBillingInfoOptions = {}) {
  const { user } = useAuth();
  const { pollIntervalMs = false } = options;

  return useQuery({
    queryKey: BILLING_INFO_QUERY_KEY,
    queryFn: () => api.billing(),
    enabled: !!user,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    refetchInterval: pollIntervalMs,
  });
}

